module.exports = __webpack_public_path__ + "static/media/Hanna Choi.b9403c9f.png";